export const PillTypes = {
  COMPANY_CODES: 'COMPANY_CODES',
  BUSINESS_UNITS: 'BUSINESS_UNITS',
  LEGAL_ENTITIES: 'LEGAL_ENTITIES',
  BOOK_TO_TAX_DIFFERENCES: 'BOOK_TO_TAX_DIFFERENCES',
  TAX_RATES: 'TAX_RATES',
  OBLIGATIONS: 'OBLIGATIONS',
  TAX_BOOKING_ENTITIES: 'TAX_BOOKING_ENTITIES',
  TLS_ACCOUNTS: 'TLS_ACCOUNTS',
  TAX_ACCOUNTING: 'TAX_ACCOUNTING',
  USERS: 'USERS',
  SUBLEDGER_MAP: 'SUBLEDGER_MAP',
  CURRENCY: 'CURRENCY',
  PERIODS: 'PERIODS',
  CURRENCY_CONVERSION_RATES: 'CURRENCY_CONVERSION_RATES',
};

export const exportKey = 'exportToExcel';

export const PillDefinitions = [
  { label: 'Company Codes', type: PillTypes.COMPANY_CODES },
  { label: 'Business Units', type: PillTypes.BUSINESS_UNITS },
  { label: 'Legal Entities', type: PillTypes.LEGAL_ENTITIES },
  { label: 'Book to Tax Differences', type: PillTypes.BOOK_TO_TAX_DIFFERENCES },
  { label: 'Tax Rates', type: PillTypes.TAX_RATES },
  { label: 'Obligations', type: PillTypes.OBLIGATIONS },
  { label: 'Tax Booking Entities', type: PillTypes.TAX_BOOKING_ENTITIES },
  { label: 'TLS Accounts', type: PillTypes.TLS_ACCOUNTS },
  { label: 'Tax Accounting', type: PillTypes.TAX_ACCOUNTING },
  { label: 'Users', type: PillTypes.USERS },
  { label: 'Subledger Map', type: PillTypes.SUBLEDGER_MAP },
  { label: 'Currency', type: PillTypes.CURRENCY },
  { label: 'Periods', type: PillTypes.PERIODS },
  { label: 'Currency Conversion Rates', type: PillTypes.CURRENCY_CONVERSION_RATES },
];

export const getPillDefinitions = () => PillDefinitions;

export const Resources = {
  [PillTypes.COMPANY_CODES]: 'companyCodes',
  [PillTypes.BUSINESS_UNITS]: 'businessUnits',
  [PillTypes.LEGAL_ENTITIES]: 'legalEntities',
  [PillTypes.BOOK_TO_TAX_DIFFERENCES]: 'bookToTaxDifferences',
  [PillTypes.TAX_RATES]: 'taxRates',
  [PillTypes.OBLIGATIONS]: 'obligations',
  [PillTypes.TAX_BOOKING_ENTITIES]: 'taxBookingEntities',
  [PillTypes.TLS_ACCOUNTS]: 'tlsAccounts',
  [PillTypes.TAX_ACCOUNTING]: 'taxAccounting',
  [PillTypes.USERS]: 'users',
  [PillTypes.SUBLEDGER_MAP]: 'subledgerMap',
  [PillTypes.CURRENCY]: 'currency',
  [PillTypes.PERIODS]: 'periods',
  [PillTypes.CURRENCY_CONVERSION_RATES]: 'currencyConversionRates',
  [exportKey]: exportKey,
};

export const numberOfPills = PillDefinitions.length;
